<script setup lang="ts">
import TypFb from "~/components/icons/typ/typ-fb.vue";
import TypIg from "~/components/icons/typ/typ-ig.vue";
import SovendusWidget from "~/components/static/SovendusWidget.vue";
import { sovendusAvailable } from "~/utils/service";

const locale = await getLocale("typ", "typ_metlife_ok");
const emit = defineEmits(["init"]);

defineComponent({
  name: "TypMetlifeOK",
});

defineProps({
  name: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
  showSovendus: {
    type: Boolean,
    default: true
  }
});

onMounted(() => emit("init"));
</script>

<template>
  <div
    class="w-11/12 sm:max-w-7xl mx-auto shadow-lg rounded-3xl bg-white mt-4 mb-10 lg:my-10"
  >
    <div
      class="px-4 mx-auto lg:container text-sm sm:text-base leading-tight text-gray-700"
    >
      <h3
        class="px-2 pt-6 pb-5 text-center text-2xl sm:text-3xl font-semibold"
        v-html="locale.header.replace('%d', name)"
      ></h3>
      <div class="max-w-4xl text-lg mx-auto px-4 pb-4">
        <h1
          class="text-2xl font-bold text-center mt-2 mb-8"
          v-html="locale.title.replace('%t', type)"
        ></h1>
        <p class="mb-8 text-center" v-html="locale.instructions.first"></p>
        <!--<p class="mb-4 text-center" v-html="locale.email_information"></p>-->

        <p class="text-center mt-10" v-html="locale.thanks"></p>
      </div>
    </div>
    <div class="spacer h-6" />
    <SovendusWidget v-if="sovendusAvailable() && showSovendus" />
  </div>
</template>

<style scoped></style>
